(function ($, window) {
    $(function () {
        // Explainer
        var $currentTooltip;
        var showTimeout;
        var hideTiemout;

        $('.c-explainer').on('mouseenter', function (e) {
            var $this = $(this);

            clearTimeout(hideTiemout);
            if ($currentTooltip) {
                $currentTooltip.attr('style', '');
                $currentTooltip.detach().appendTo($this);
            }

            $currentTooltip = $this.find('.c-explainer__tooltip');
            $currentTooltip.removeClass('h-pos-left');
            $currentTooltip.removeClass('h-pos-right');
            $currentTooltip.removeClass('h-pos-down');

            if (($currentTooltip.offset().left + $currentTooltip.outerWidth()) > $(window).outerWidth()) {
                $currentTooltip.addClass('h-pos-left');
            }

            if ($currentTooltip.offset().left < 0) {
                $currentTooltip.addClass('h-pos-right');
            }

            if ($currentTooltip.offset().top < $('.c-site-header').outerHeight()) {
                $currentTooltip.addClass('h-pos-down');
            }

            $currentTooltip.css('left', $currentTooltip.offset().left);
            $currentTooltip.css('right', 'auto');
            $currentTooltip.css('top', $currentTooltip.offset().top);
            $currentTooltip.css('bottom', 'auto');
            $currentTooltip.css('margin-left', '0');
            $currentTooltip.detach().appendTo('body');

            showTimeout = setTimeout(function () {
                $currentTooltip.addClass('h-is-active');
            }, 100);
        })
            .on('mouseleave', function (e) {
                clearTimeout(showTimeout);
                $currentTooltip.removeClass('h-is-active');

                var $this = $(this);

                $currentTooltip.removeClass('h-is-active');

                hideTiemout = setTimeout(function () {
                    $currentTooltip.attr('style', '');
                    $currentTooltip.detach().appendTo($this);
                    $currentTooltip = false;
                }, 300);
            });
    });
})(jQuery, window);